import { render } from "./NextUIIndicator.vue?vue&type=template&id=977c88e6&scoped=true&ts=true"
import script from "./NextUIIndicator.vue?vue&type=script&lang=ts"
export * from "./NextUIIndicator.vue?vue&type=script&lang=ts"

import "./NextUIIndicator.vue?vue&type=style&index=0&id=977c88e6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977c88e6"]])

export default __exports__